import ReportService from "../../../services/ReportService";
class DailyStatsFilter {
  momentToFormat = (m) => m.format("YYYY-MM-DD");

  async getDailyStatsReport(selectedDate, userGroup) {
    try {
      const response = await ReportService.getDailyStatsReport(
        this.momentToFormat(selectedDate),
        userGroup
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}
const dailyStatsFilter = new DailyStatsFilter();
export default dailyStatsFilter;
